import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledDropdown,
  Form,
  FormFeedback,
  Spinner
} from "reactstrap";

import * as Yup from "yup";
import { useFormik } from "formik";
import DeleteModal from "../../Components/Common/DeleteModal";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Widgets from "./Widgets";
import TableContainer from "../../Components/Common/TableContainer";
import { APIKeys, CreatedBy, ExpiryDate, Name, Status, CreatedDate } from "./APIKeyCol";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { createNewAPIKey, disableAPIKey, enableAPIKey, getAPIKey, renameAPIKey } from "../../helpers/fakebackend_helper";

const APIKey = () => {
  document.title = "API Key | Velzon -  Admin & Dashboard Template";
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [newApiName, setNewApiName] = useState("")
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [selectedApiKey, setSelectedApiKey] = useState(null);
  const [allApiKeys, setAllApiKeys] = useState([])
  const [modalMessage, setModalMessage] = useState("");
  const [renameModal, setRenameModal] = useState(false);
  const [renameKey, setRenameKey] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [renameLoading, setRenameLoading] = useState(false);

  const onRenameSave = async () => {
    if (!renameValue.trim()) return;
    setRenameLoading(true);
    try {
      const result = await renameAPIKey(renameKey.api_key, renameValue.trim());
      if (result.success) {
        setRenameModal(false);
        loadData();
      } else {
        alert(result.message);
      }
    } finally {
      setRenameLoading(false);
    }
  };
  const onClickDelete = () => {
    setDeleteModal(true);
  };
  const onDeleteApiClick = async ()=>{
    var result = {}
    console.log(selectedApiKey)
    if(selectedApiKey.is_enabled){
      result = await disableAPIKey(selectedApiKey.api_key);
      
    }
    else{
      result = await enableAPIKey(selectedApiKey.api_key);
    }
    if(result.success){
      setDeleteModal(false);
      loadData()
    }
    else{
      alert(result.message)
    }
  }

  const apikeyData = createSelector(
    (state) => state.APIKey,
    (apiKey) => apiKey.apiKey
  );
  // const APIKey = useSelector(apikeyData);

  useEffect(() => {
    loadData()
  }, []);
  const loadData = async () => {
    const keys = await getAPIKey();
    // const all = await keys()
    console.log(keys)
    setAllApiKeys(keys.data)
  }
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      newApiName: newApiName || '',
    },
    validationSchema: Yup.object({
      newApiName: Yup.string().required("Please Enter Api Key Name"),
    }),
    onSubmit: async (values) => {
      // console.log(values)
      setLoading(true)
      const response = await createNewAPIKey(values.newApiName)
      console.log(response)
      if (response.success) {
        loadData()
        setShow(false)
      }
      setLoading(false)
      // dispatch(loginUser(values, props.router.navigate));
    }
  });
  // Checked All
  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".orderCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };
  const columns = useMemo(
    () => [
      {
        header: (
          <Input
            type="checkbox"
            id="checkBoxAll"
            className="form-check-input"
            onClick={() => checkedAll()}
          />
        ),
        cell: (cell) => {
          return (
            <Input
              type="checkbox"
              className="orderCheckBox form-check-input"
              value={cell.getValue()}
            />
          );
        },
        id: "#",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell) => {
          return <Name {...cell} />;
        },
      },
      {
        header: "API Key",
        accessorKey: "api_key",
        enableColumnFilter: false,
        border: "1px solid black",
        cell: (cell) => {
          return <APIKeys {...cell} />;
        },
      },
      {
        header: "Status",
        accessorKey: "is_enabled",
        enableColumnFilter: false,
        cell: (cell) => {
          return <Status {...cell} />;
        },
      },
      {
        header: "Created Date",
        accessorKey: "create_time",
        enableColumnFilter: false,
        cell: (cell) => {
          return <CreatedDate {...cell} />;
        },
      },

      {
        header: "Action",
        disableFilters: true,
        enableSorting: false,
        cell: (cell) => {
          return (
            <UncontrolledDropdown className="dropdown">
              <DropdownToggle
                role="button"
                tag="button"
                className="btn btn-soft-secondary btn-sm dropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ri-more-fill align-middle"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu dropdown-menu-end">
                <li>
                  <DropdownItem
                    className="edit-item-btn"
                    onClick={() => {
                      setRenameKey(cell.row.original);
                      setRenameValue(cell.row.original.name || "");
                      setRenameModal(true);
                    }}
                  >
                    Rename
                  </DropdownItem>
                </li>

                <li>
                  <DropdownItem className="disable-btn" to="#" onClick={() => {
                    setSelectedApiKey(cell.row.original)
                    setModalMessage(<span>Do you want to {cell.row.original.is_enabled ? "disable" : "enable"} <b>"{cell.row.original.name}"</b> api key</span>)
                    onClickDelete()
                  }}>
                    {/* {JSON.stringify(cell.row.original)} */}
                    {cell.row.original.is_enabled ? "Disable" : "Enable"}
                  </DropdownItem>
                </li>

              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <DeleteModal
          show={deleteModal}
          onCloseClick={() => setDeleteModal(false)}
          message={modalMessage}
          onDeleteClick={onDeleteApiClick}
        />
        {/* <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        /> */}
        <Container fluid>
          <BreadCrumb title="API Key" pageTitle="Apps" />

          {/* <Row>
            <Widgets />
          </Row> */}

          <Row>
            <Col lg={12}>
              <Card id="apiKeyList">
                <CardHeader className="d-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">API Keys</h5>
                  <div className="d-flex gap-1 flex-wrap">
                    <Button
                      type="button"
                      color="primary"
                      className="btn create-btn"
                      data-bs-toggle="modal"
                      onClick={handleShow}
                      data-bs-target="#api-key-modal"
                    >
                      <i className="ri-add-line align-bottom me-1"></i> Add API
                      Key
                    </Button>
                  </div>
                </CardHeader>
                <CardBody>
                  <div>
                    <TableContainer
                      columns={columns}
                      data={allApiKeys || []}
                      // hadleApiKey={hadleApiClicks}
                      customPageSize={8}
                      divClass="table-responsive table-card mb-3  "
                      tableClass="table align-middle table-nowrap mb-0"
                      theadClass="table-light"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <div
        className="modal fade"
        id="api-key-modal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <Modal isOpen={show} toggle={handleClose} className="modal-content">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
              action="#">
              <ModalHeader className="modal-header">Create API Key</ModalHeader>
              <ModalBody className="modal-body">

                <div
                  id="api-key-error-msg"
                  className="alert alert-danger py-2 d-none"
                ></div>
                <Input type="hidden" id="apikeyId" />
                <div className="mb-3">
                  <Label htmlFor="api-key-name" className="form-label">
                    API Key Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    name="newApiName"
                    className="form-control"
                    placeholder="Enter api key name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.newApiName || ""}
                    invalid={
                      validation.touched.newApiName && validation.errors.newApiName ? true : false
                    }
                  />
                  {validation.touched.newApiName && validation.errors.newApiName ? (
                    <FormFeedback type="invalid">{validation.errors.newApiName}</FormFeedback>
                  ) : null}

                </div>
                <div
                  className="mb-3"
                  id="apikey-element"
                  style={{ display: "none" }}
                >
                  <Label htmlFor="api-key" className="form-label">
                    API Key
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="api-key"
                    disabled
                    value="b5815DE8A7224438932eb296Z5"
                  />
                </div>
              </ModalBody>
              <div className="modal-footer">
                <div className="hstack gap-2 justify-content-end">
                  <Button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    id="createApi-btn"
                    disabled={error ? null : loading ? true : false}
                  >
                    {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : null}
                    Create API
                  </Button>
                </div>
              </div>

            </Form>
          </Modal>
        </div>
      </div>

      <Modal isOpen={renameModal} toggle={() => setRenameModal(false)} centered>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onRenameSave();
            return false;
          }}
        >
          <ModalHeader toggle={() => setRenameModal(false)}>Rename API Key</ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <Label htmlFor="rename-api-key" className="form-label">
                API Key Name <span className="text-danger">*</span>
              </Label>
              <Input
                id="rename-api-key"
                className="form-control"
                placeholder="Enter api key name"
                type="text"
                value={renameValue}
                onChange={(e) => setRenameValue(e.target.value)}
                invalid={renameValue.trim() === ""}
              />
              {renameValue.trim() === "" ? (
                <FormFeedback type="invalid">Please Enter Api Key Name</FormFeedback>
              ) : null}
            </div>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <Button type="button" className="btn btn-secondary" onClick={() => setRenameModal(false)}>
                Close
              </Button>
              <Button type="submit" color="primary" disabled={renameLoading || renameValue.trim() === ""}>
                {renameLoading ? <Spinner size="sm" className="me-2" /> : null}
                Save
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default APIKey;
